<template>
  <div class="wrapper">
    <navbar />
    <Sidebar />


    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">

      <router-view></router-view> <!-- Aquí se mostrarán las vistas adicionales -->
    </div>
    <!-- /.content-wrapper -->

    <footer class="main-footer">
      <div class="float-right d-none d-sm-block">
        <b>Version</b> 3.2.0
      </div>
      <strong>Copyright &copy; 2014-2021 <a href="https://adminlte.io">AdminLTE.io</a>.</strong> All rights reserved.
    </footer>

    <!-- Control Sidebar -->
    <aside class="control-sidebar control-sidebar-dark">
      <!-- Control sidebar content goes here -->
    </aside>
    <!-- /.control-sidebar -->
  </div>

</template>

<script>
import Navbar from './inc/Navbar.vue'
import Sidebar from './inc/Sidebar.vue'
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  components: {
    Navbar,
    Sidebar
  },
  mounted() {
    // Interceptor global para manejar errores 401 (Unauthorized)
    this.axiosInterceptor = axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          if (!window.isSessionAlertOpen) {
            window.isSessionAlertOpen = true;
            Swal.fire('Sesión Expirada', 'Su sesión ha caducado. Por favor, inicie sesión de nuevo.', 'warning').then(() => {
               window.isSessionAlertOpen = false;
               this.$router.push('/login');
            });
          }
        }
        return Promise.reject(error);
      }
    );
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        if (window.jQuery) {
          window.jQuery('[data-widget="treeview"]').Treeview('init');
        }
      });
    }
  },
  beforeUnmount() {
    if (this.axiosInterceptor) {
      axios.interceptors.response.eject(this.axiosInterceptor);
    }
  }


}
</script>